import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import RetailDesignationForm from "./RetailDesignationsForm";
import LdnDesignationForm from "./LdnDesignationForm";
import Logo from "~/images/AstraZeneca.png";

const AstrazenecaDesignations = ({ entities, setCompletedDesignations }) => {
  const manufacturer = "astrazeneca";
  const manufacturerName = "AstraZeneca";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] =
    useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    astrazeneca: {},
  });

  useEffect(() => {
    setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const sharedProps = {
    entities,
    manufacturer,
    manufacturerName,
    manufacturerFormDetails,
    setManufacturerFormDetails,
    retailSelectedSpecialtyPharmacy,
    retailHasSelectedSpecialtyPharmacy,
  };

  const renderDesignationForm = (Component, specialtyKeyName) => (
    <Component
      {...sharedProps}
      isBlocked={_.some(entities, (e) => e.blocked.includes(specialtyKeyName))}
      productName={specialtyKeyName}
    />
  );

  const isComplete = () => {
    var completed = true;

    var openForms = _.map(manufacturerFormDetails, (manufacturer) => {
      return _.filter(manufacturer, (form) => {
        return form.open;
      });
    });

    // remove empty arrays and flatten
    var filteredForms = openForms.filter((e) => e.length).flat();

    if (filteredForms.length) {
      completed = _.every(filteredForms, ["completed", true]);
    }

    return completed;
  };

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={Logo} />
        </div>
        <div className="designation_form__section__header__title">{manufacturerName}</div>
      </div>
      {renderDesignationForm(RetailDesignationForm, "retail")}
      {renderDesignationForm(LdnDesignationForm, "tagrisso")}
      {renderDesignationForm(LdnDesignationForm, "lynparza")}
      {renderDesignationForm(LdnDesignationForm, "truqap")}
      {renderDesignationForm(LdnDesignationForm, "fasenra")}
      {renderDesignationForm(LdnDesignationForm, "etcamah")}
    </div>
  );
};

export default AstrazenecaDesignations;
